import { EmptyPage } from './empty-page'
import { ReportLoading } from './loading-page'
export {
  EmptyPage,
  ReportLoading
}